module.exports = __webpack_public_path__ + "static/image4-fa185ce72486f96904735d7acc525894.jpg";